export default __webpack_public_path__ + "static/media/Macrobac-35-ml-eng.d2e9cfc6.jpg";